import { GridProps, StackProps, SxProps, TypographyProps } from "@mui/material";
import muiVariables from "../../styles/mui-variables";

const DeleteModelStyle = {
  deletModelMainGrid: {
    maxWidth: "100%",
    alignItems: { sm: "center", lg: "flex-start" },
    justifyContent: { sm: "center", lg: "flex-start" },
  } as GridProps,
  deleteModelWrapStack: {
    mt: 4,
    direction: "row",
    spacing: 2,
    justifyContent: "center",
    alignItems: "center",
    gap: "5px",
  } as StackProps,
  deleteBtnModelCancelSx: {
    width: "144px",
    backgroundColor: muiVariables.primaryColor,
    borderColor: muiVariables.borderColor,
    color: muiVariables.mainTextColor,
    padding: "0px !important",
    "&:hover": {
      borderColor: muiVariables.borderColor,
    },
  } as SxProps,
  deleteBtnModelSx: {
    width: "200px",
    backgroundColor: muiVariables.deleteTextColor,
    borderColor: muiVariables.borderColor,
    padding: "0px !important",
    color: `${muiVariables.primaryColor}`,
    "&:hover": {
      backgroundColor: muiVariables.deleteTextColor,
      boxShadow: "none",
    },
  } as SxProps,
  titleMain: {
    textAlign: "center",
    fontWeight: "500",
    marginBottom: "15px",
    fontSize: muiVariables.subHeadingFontSize,
    color: muiVariables.subTextColor
  } as SxProps,
  modelDes1: {
    textAlign: "center",
    color: muiVariables.subTextColor,
    fontWeight: "500",
    fontSize: `${muiVariables.subHeadingFontSize} !important`,
  } as TypographyProps,
};

export default DeleteModelStyle;
